export const accountinfo = {
  email: {
    type: 'input',
    label: 'Communication Email Address',
    labelGuj:'ઈમેલ',
    value: '',
    config: {
      placeholder: 'Your Email Address',
      help_text: 'You will receive all notifications on this email',
    },
    validation: {
      required: true,
      isEmail: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  bureau: {
    type: 'async_select_single',
    label: 'Bureau',
    labelGuj:'બ્યુરો',
    value: '',
    config: {
      placeholder: 'Select bureau',
      help_text: 'Select the bureau you registered at',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  first_name: {
    type: 'input',
    value: '',
    config: {
      placeholder: 'Enter only First Name',
      help_text: 'First Name (નામ)',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  last_name: {
    type: 'input',
    value: '',
    config: {
      placeholder: 'Enter only Last Name',
      help_text: 'Last Name (અટક)',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  country_code: {
    type: 'async_select_single',
    label: 'Country Code',
    labelGuj: 'કોડ',
    value: '',
    config: {
      placeholder: 'Select country code',
      isSearchable: true,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  phone: {
    type: 'input',
    label: 'Mobile No.',
    labelGuj:'મોબાઇલ નંબર',
    value: '',
    config: {
      placeholder: 'Enter Mobile no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  gender: {
    type: 'select',
    label: 'Gender',
    labelGuj:'લિંગ',
    value: '',
    validation: {
      required: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: {
      M: 'Male',
      F: 'Female',
    },
  },
  lohana_connect_id: {
    type: 'input',
    label: 'Lohana Connect ID',
    labelGuj:'લોહાણા કનેક્ટ આઈડી',
    value: "",
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    config: {
      placeholder: 'Enter your lohana connect ID'
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false
  }
};


const heightOptions = {};
for (let i = 4; i <= 6; i += 1) {
  for (let j = 0; j <= 11; j += 1) {
    const ft = i;
    let inch = j;
    inch += (ft * 12);
    const cm = inch * 2.54;
    heightOptions[parseInt(cm, 10)] = `${i}ft ${j}in`;
  }
}


export const personalinfo = {
  birth_date: {
    type: 'date',
    label: 'Date of Birth (YYYY-MM-DD)',
    labelGuj:'જન્મ તારીખ',
    value: null,
    config: {
      emptyLabel: 'Select date',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  birth_time: {
    type: 'time',
    label: 'Time of Birth',
    labelGuj:'જન્મ સમય',
    value: null,
    config: {
      emptyLabel: 'Select time',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  birth_place: {
    type: 'input',
    label: 'Place of Birth',
    labelGuj:'જન્મ સ્થળ',
    value: '',
    config: {
      placeholder: 'Search and select place of birth',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  caste: {
    type: 'async_select_single',
    label: 'Caste',
    labelGuj:'જાતિ',
    value: '',
    config: {
      placeholder: 'Select caste',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  marital_status: {
    type: 'async_select_single',
    label: 'Marital Status',
    labelGuj:'વૈવાહિક સ્થિતિ',
    value: '',
    config: {
      placeholder: 'Select marital status',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  height: {
    type: 'select',
    label: 'Height',
    labelGuj:'ઊંચાઈ',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: heightOptions,
  },
  weight: {
    type: 'input',
    label: 'Weight in kgs',
    labelGuj:'વજન',
    value: '',
    config: {
      type: 'number',
      placeholder: 'Enter your weight',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  about: {
    type: 'input',
    label: 'About you',
    labelGuj:'તમારા વિશે',
    value: '',
    config: {
      help_text: 'Max 300 characters allowed. Don\'t mention your education and work. We have a section for that later',
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  marriage_end_year: {
    type: 'input',
    label: 'Year of Divorced/Widowed',
    labelGuj:'વિધવા/છૂટાછેડા લીધેલનું વર્ષ',
    value: '',
    config: {
      placeholder: 'Please enter year',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  marriage_years_count: {
    type: 'input',
    label: 'No. of years of marriage',
    labelGuj:'લગ્નના વર્ષ',
    value: '',
    config: {
      placeholder: 'Please enter duration in months/years',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  children: {
    type: 'input',
    label: 'Children',
    labelGuj:'બાળકો',
    value: '',
    config: {
      placeholder: 'No. of children',
      help_text: 'Enter no. of sons/daughters with age',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  legal: {
    type: 'input',
    label: 'Legality',
    labelGuj:'કાયદેસરતા',
    value: '',
    config: {
      placeholder: 'Legal Information',
      help_text: 'Legal papers cleared Yes/No. If yes, which year',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const lifestyleinfo = {
  body_type: {
    type: 'async_select_single',
    label: 'Body Type',
    labelGuj:'શારીરિક બાંધો',
    value: '',
    config: {
      placeholder: 'Select body type',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  physical_disabilities: {
    type: 'input',
    label: 'Physical Disablilities (if any)',
    labelGuj:'શારીરિક અક્ષમતા (જો કોઈ હોય તો)',
    value: '',
    config: {
      placeholder: 'Enter any physical disabilities',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: '',
    valid: true,
    touched: true,
  },
  diet: {
    type: 'async_select_single',
    label: 'Diet',
    labelGuj:'આહાર',
    value: '',
    config: {
      placeholder: 'Select diet',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  // smoke: {
  //   type: 'async_select_single',
  //   label: 'Smoke',
  //   labelGuj:'ધૂમ્રપાન ',
  //   value: '',
  //   config: {
  //     placeholder: 'Select smoke',
  //     isSearchable: false,
  //     defaultOptions: true,
  //   },
  //   validation: {
  //     isValueRequired: false,
  //   },
  //   errorMsg: 'Missing',
  //   valid: true,
  //   touched: true,
  // },
  // drink: {
  //   type: 'async_select_single',
  //   label: 'Drink',
  //   labelGuj:'મદિરાપાન / મદ્યપાન',
  //   value: '',
  //   config: {
  //     placeholder: 'Select drink',
  //     isSearchable: false,
  //     defaultOptions: true,
  //   },
  //   validation: {
  //     isValueRequired: false,
  //   },
  //   errorMsg: 'Missing',
  //   valid: true,
  //   touched: true,
  // },
  thalassemia: {
    type: 'async_select_single',
    label: 'Thalassemia',
    labelGuj: 'થેલેસેમિયા',
    value: '',
    config: {
      placeholder: 'Select thalassemia Result',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  // report: {
  //   type: 'file',
  //   label: 'Add Thalassemia Report',
  //   value: '',
  //   config: {
  //     type: 'file',
  //   },
  //   validation: {
  //     isValueRequired: true,
  //   },
  //   errorMsg: 'Missing',
  //   valid: false,
  //   touched: false,
  // },
};


export const educationinfo = {
  qualification: {
    type: 'async_select_single',
    label: 'Qualification',
    labelGuj:'શૈક્ષણિક લાયકાત',
    value: '',
    config: {
      placeholder: 'Select qualification',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  profession: {
    type: 'async_select_single',
    label: 'Profession',
    labelGuj:'વ્યવસાય',
    value: '',
    config: {
      placeholder: 'Select profession',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  degree: {
    type: 'async_select_multiple',
    label: 'Degree',
    labelGuj:'પદવી & ડિગ્રી',
    value: '',
    config: {
      placeholder: 'Select degrees',
      defaultOptions: true,
      help_text: 'You can select multiple options',
      isOptionDisabled: (value) => {
        return value.is_parent === true;
      },
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  // about_education: {
  //   type: 'input',
  //   label: 'About your Education',
  //   labelGuj:'તમારા શિક્ષણ વિશે',
  //   value: '',
  //   config: {
  //     placeholder: 'max 300 characters allowed',
  //     multiline: true,
  //     rows: 4,
  //   },
  //   validation: {
  //     required: true,
  //   },
  //   errorMsg: 'Missing',
  //   valid: false,
  //   touched: false,
  // },
  work_profile: {
    type: 'async_select_single',
    label: 'Work Profile/Designation*',
    labelGuj:'વર્ક પ્રોફાઈલ/હોદ્દો',
    value: '',
    config: {
      placeholder: 'Select work profile',
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  self_city: {
    type: 'async_select_single',
    label: 'Self/Office City',
    labelGuj:'સ્વયંનું / ઓફિસનું  શહેર',
    value: '',
    config: {
      placeholder: 'Search and select city',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  income: {
    type: 'async_select_single',
    label: 'Annual Income (Self)',
    labelGuj:'વાર્ષિક આવક (પોતાની)',
    value: '',
    config: {
      placeholder: 'Select income range',
      defaultOptions: true,
      isSearchable: false,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  family_income: {
    type: 'async_select_single',
    label: 'Annual Income (Household)',
    labelGuj:'વાર્ષિક આવક (કુટુંબની)',
    value: '',
    config: {
      placeholder: 'Select income range',
      defaultOptions: true,
      isSearchable: false,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  // about_career: {
  //   type: 'input',
  //   label: 'About your Work Profile',
  //   labelGuj:'તમારા કામ વિશે',
  //   value: '',
  //   config: {
  //     placeholder: 'max 300 characters allowed',
  //     multiline: true,
  //     rows: 4,
  //   },
  //   validation: {
  //     required: true,
  //   },
  //   errorMsg: 'Missing',
  //   valid: false,
  //   touched: false,
  // },

};


export const familyinfo = {
  father_name: {
    type: 'input',
    label: 'Father\'s Name',
    labelGuj:'પિતાનું નામ',
    value: '',
    config: {
      placeholder: 'Your father\'s name',
      help_text: 'Enter only first name',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mother_name: {
    type: 'input',
    label: 'Mother\'s Name',
    labelGuj:'માતાનું નામ',
    value: '',
    config: {
      placeholder: 'Your mother\'s name',
      help_text: 'Enter only first name',
    },
    validation: {
      required: true,
      noSpacesAllowed: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  father_occupation: {
    type: 'async_select_single',
    label: 'Father\'s Occupation',
    labelGuj:'પિતાનો વ્યવસાય',
    value: '',
    config: {
      placeholder: 'Select occupation',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: false,
  },
  mother_occupation: {
    type: 'async_select_single',
    label: 'Mother\'s Occupation',
    labelGuj:'માતાનો વ્યવસાય',
    value: '',
    config: {
      placeholder: 'Select occupation',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: false,
  },
  residence_type: {
    type: 'async_select_single',
    label: 'Residence Type',
    labelGuj:'રહેઠાણનો પ્રકાર',
    value: '',
    config: {
      placeholder: 'Select type of residence',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  native_place: {
    type: 'input',
    label: 'Native Place',
    labelGuj:'વતન',
    value: '',
    config: {
      placeholder: 'Your native place',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mosal: {
    type: 'input',
    label: 'Mosal (Mother Maiden Surname)',
    labelGuj:'મોસાળ (અટક)',
    value: '',
    config: {
      placeholder: 'Your mosal surname',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  // nanaji: {
  //   type: 'input',
  //   label: 'Nanaji\'s name',
  //   labelGuj:'નાનાજીનું નામ',
  //   value: '',
  //   config: {
  //     placeholder: 'Your nanaji\'s name',
  //   },
  //   validation: {
  //     required: true,
  //   },
  //   errorMsg: 'Missing',
  //   valid: false,
  //   touched: false,
  // },
  brother_count: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Total',
      type: 'number',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  brother_married: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Married',
      type: 'number',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  sister_count: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Total',
      type: 'number',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  sister_married: {
    type: 'input',
    value: 0,
    config: {
      help_text: 'Married',
      type: 'number',
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  family_city: {
    type: 'async_select_single',
    label: 'Family Residence City',
    labelGuj:'કુટુંબ રહેઠાણનું શહેર',
    value: '',
    config: {
      placeholder: 'Search and select city',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  location: {
    type: 'input',
    label: 'Location',
    labelGuj:'સ્થાન',
    value: '',
    config: {
      placeholder: 'Location (eg. Santacruz, Kandivali, etc)',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  father_contact: {
    type: 'input',
    label: 'Father\'s Contact no.',
    labelGuj:'પિતાનો સંપર્ક નંબર',
    value: '',
    config: {
      placeholder: 'Father\'s Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mother_contact: {
    type: 'input',
    label: 'Mother\'s Contact no.',
    labelGuj:'માતાનો સંપર્ક નંબર',
    value: '',
    config: {
      placeholder: 'Mother\'s Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const contactinfo = {
  self_address: {
    type: 'input',
    label: 'Office Address',
    labelGuj:'ઓફિસનું  સરનામું',
    value: '',
    config: {
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  self_city: {
    type: 'async_select_single',
    label: 'Self/Office City',
    labelGuj:'સ્વયંનું / ઓફિસનું  શહેર',
    value: '',
    config: {
      placeholder: 'Search and select city',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  self_contact_no: {
    type: 'input',
    label: 'Self/Office No.',
    labelGuj:'સ્વયંનો / ઓફિસનો નંબર',
    value: '',
    config: {
      placeholder: 'Enter contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  family_address: {
    type: 'input',
    label: 'Family Residence Address',
    labelGuj:'કૌટુંબિક રહેઠાણનું સરનામું',
    value: '',
    config: {
      placeholder: 'max 300 characters allowed',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  family_city: {
    type: 'async_select_single',
    label: 'Family Residence City',
    labelGuj:'કુટુંબ રહેઠાણનું શહેર',
    value: '',
    config: {
      placeholder: 'Search and select city',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  location: {
    type: 'input',
    label: 'Location',
    labelGuj:'સ્થાન',
    value: '',
    config: {
      placeholder: 'Location (eg. Santacruz, Kandivali, etc)',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  residence_type: {
    type: 'async_select_single',
    label: 'Residence Type',
    labelGuj:'રહેઠાણનો પ્રકાર',
    value: '',
    config: {
      placeholder: 'Select type of residence',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  rooms_count: {
    type: 'input',
    label: 'No. of rooms (BHK)',
    labelGuj:'રૂમોની સંખ્યા (BHK)',
    value: '',
    config: {
      type: 'number',
      placeholder: 'Enter how many BHK',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  residence_area: {
    type: 'input',
    label: 'Area in sqft.',
    labelGuj:'ઘરનો વિસ્તાર',
    value: '',
    config: {
      type: 'number',
      placeholder: 'Area in sqft.',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  residence_phone: {
    type: 'input',
    label: 'Residence Contact no.',
    labelGuj:'રહેઠાણ સંપર્ક નંબર',
    value: '',
    config: {
      placeholder: 'Residence Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  father_contact: {
    type: 'input',
    label: 'Father\'s Contact no.',
    labelGuj:'પિતાનો સંપર્ક નંબર',
    value: '',
    config: {
      placeholder: 'Father\'s Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mother_contact: {
    type: 'input',
    label: 'Mother\'s Contact no.',
    labelGuj:'માતાનો સંપર્ક નંબર',
    value: '',
    config: {
      placeholder: 'Mother\'s Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const referenceinfo = {
  name: {
    type: 'input',
    label: 'Name',
    labelGuj:'નામ',
    value: '',
    config: {
      placeholder: 'Reference Name',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  phone: {
    type: 'input',
    label: 'Contact No.',
    labelGuj:'સંપર્ક નંબર',
    value: '',
    config: {
      placeholder: 'Reference Contact no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  place: {
    type: 'input',
    label: 'Location of Reference Person',
    labelGuj:'રેફ્રન્સનું સ્થાન',
    value: '',
    config: {
      placeholder: 'Reference Location (eg. Santacruz, Kandivali, etc)',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  address: {
    type: 'input',
    label: 'Mahajan Address',
    labelGuj:'મહાજનનું સરનામું',
    value: '',
    config: {
      placeholder: 'Mahajan Address',
      multiline: true,
      rows: 4,
    },
    validation: {
      required: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: false,
  },
  relation: {
    type: 'input',
    label: 'Relation',
    labelGuj:'સંબંધ',
    value: '',
    config: {
      placeholder: 'Your Relation With Reference',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  mahajan: {
    type: 'input',
    label: 'Mahajan',
    labelGuj:'મહાજન',
    value: '',
    config: {
      placeholder: 'Your Mahajan Details',
    },
    validation: {
      required: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: false,
  },
};


export const fileupload = {
  file: {
    type: 'file',
    labelGuj:'નવી ફાઇલ ઉમેરો',
    label: 'Add new file',
    value: '',
    config: {
      type: 'file',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};

export const report = {
  file: {
    type: 'file',
    labelGuj:'નવી ફાઇલ ઉમેરો',
    label: 'Add new file',
    value: '',
    config: {
      type: 'file',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
};


export const iduploadaadhar = {
  file: {
    type: 'file',
    labelGuj:'નવી ફાઇલ ઉમેરો',
    label: 'Add new file',
    value: '',
    config: {
      type: 'file',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  id_proof_no: {
    type: 'input',
    label: 'Aadhaar No.',
    labelGuj:'આધાર નંબર',
    value: '',
    config: {
      placeholder: 'Your Aadhaar no.',
    },
    validation: {
      required: true,
    },
    errorMsg: 'Enter valid aadhaar no.',
    valid: false,
    touched: false,
  },
};


export const idupload = {
  file: {
    type: 'file',
    labelGuj:'નવી ફાઇલ ઉમેરો',
    label: 'Add new file',
    value: '',
    config: {
      type: 'file',
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  id_proof_no: {
    type: 'input',
    label: 'Id Proof No.',
    labelGuj:'આઈડીપ્રૂફ નંબર',
    value: '',
    config: {
      placeholder: 'Your id-proof no.',
    },
    validation: {
      required: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: false,
  },
};


const ageOptions = {};
for (let index = 19; index < 61; index += 1) {
  ageOptions[index] = index;
}


export const partnerchoice = {
  from_age: {
    type: 'select',
    label: 'From age',
    labelGuj:'ઉંમરથી',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: ageOptions,
  },
  to_age: {
    type: 'select',
    label: 'To age',
    labelGuj:'ઉંમર સુધી',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: ageOptions,
  },
  from_height: {
    type: 'select',
    label: 'From Height',
    labelGuj:'ઊંચાઈથી',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: heightOptions,
  },
  to_height: {
    type: 'select',
    label: 'To Height',
    labelGuj:'ઊંચાઈ સુધી',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: heightOptions,
  },
  marital_status: {
    type: 'async_select_multiple',
    label: 'Marital Status',
    labelGuj:'વૈવાહિક સ્થિતિ',
    value: '',
    validation: {
      isValueRequired: false,
    },
    config: {
      placeholder: 'Select marital status',
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  caste: {
    type: 'async_select_multiple',
    label: 'Caste',
    labelGuj:'જાતિ',
    value: '',
    config: {
      placeholder: 'Select caste',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  qualification: {
    type: 'async_select_multiple',
    label: 'Qualifications',
    labelGuj:'લાયકાત',
    value: '',
    config: {
      placeholder: 'Select qualifications',
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  degree: {
    type: 'async_select_multiple',
    label: 'Degrees',
    labelGuj:'પદવી & ડિગ્રી',
    value: '',
    config: {
      placeholder: 'Select degrees',
      isSearchable: false,
      defaultOptions: true,
      isOptionDisabled: (value) => {
        return value.is_parent === true;
      },
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    validation: {
      isValueRequired: false,
    },
  },
  profession: {
    type: 'async_select_multiple',
    label: 'Profession',
    labelGuj:'વ્યવસાય',
    value: '',
    config: {
      placeholder: 'Select professions',
      defaultOptions: true,
    },
    validation: {
      isValueRequired: true,
    },
    errorMsg: 'Missing',
    valid: false,
    touched: false,
  },
  work_profile: {
    type: 'async_select_multiple',
    label: 'Work Profile',
    labelGuj:'કાર્ય પ્રોફાઇલ',
    value: '',
    config: {
      placeholder: 'Select work profile',
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    validation: {
      isValueRequired: false,
    },
  },
  income: {
    type: 'async_select_multiple',
    label: 'Income',
    labelGuj:'આવક',
    value: '',
    config: {
      placeholder: 'Select income',
      isSearchable: false,
      defaultOptions: true,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    validation: {
      isValueRequired: false,
    },
  },
  country: {
    type: 'async_select_multiple',
    label: 'Country',
    labelGuj:'દેશ',
    value: '',
    config: {
      placeholder: 'Select Country',
      isSearchable: true,
      defaultOptions: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    validation: {
      isValueRequired: false,
    },
  },
  diet: {
    type: 'async_select_single',
    label: 'Diet',
    labelGuj:'આહાર',
    value: '',
    config: {
      placeholder: 'Select diet',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,

  },
  smoke: {
    type: 'async_select_single',
    label: 'Smoke',
    labelGuj:'ધૂમ્રપાન',
    value: '',
    config: {
      placeholder: 'Select smoke',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  drink: {
    type: 'async_select_single',
    label: 'Drink',
    labelGuj:'આલ્કોહોલ',
    value: '',
    config: {
      placeholder: 'Select drink',
      isSearchable: false,
      defaultOptions: true,
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
  horoscope: {
    type: 'select',
    label: 'Horoscope Required?',
    labelGuj:'જન્માક્ષર જરૂરી છે?',
    value: '',
    config: {},
    errorMsg: 'Missing',
    valid: true,
    touched: true,
    options: {
      1: 'Yes',
      0: 'No',
    },
    validation: {
      isValueRequired: false,
    },
  },
};


export const deleteProfile = {
  reason: {
    type: 'select',
    label: 'Reason',
    labelGuj:'કારણ',
    value: '',
    validation: {
      isValueRequired: true,
    },
    config: {},
    errorMsg: 'Missing',
    valid: false,
    touched: false,
    options: {
      1: 'Marriage fixed through our matrimony',
      2: 'Marriage fixed through other sources',
      3: 'Prefer to search later',
      4: 'Not getting response as expected',
      5: 'Other reasons',
    },
  },
  message: {
    type: 'input',
    label: 'Message (optional)',
    labelGuj:'સંદેશ (વૈકલ્પિક)',
    value: '',
    config: {
      placeholder: 'Optional Message',
      multiline: true,
      rows: 4,
    },
    validation: {
      isValueRequired: false,
    },
    errorMsg: 'Missing',
    valid: true,
    touched: true,
  },
};



// WEBPACK FOOTER //
// ./src/profile/utils/profileFormStates.js